// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const CardSlashIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "CardSlash/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m16.058 3.042-4.25 4.25H2.667c-.55 0-1-.45-1-1v-.009a3.446 3.446 0 0 1 3.45-3.45h9.758c.417 0 .817.075 1.183.209ZM10.558 8.542l-4.583 4.583H5a.63.63 0 0 0-.625.625c0 .258.167.492.4.575l-1.958 1.958a3.406 3.406 0 0 1-1.15-2.566V9.542c0-.55.45-1 1-1h7.891ZM18.333 9.167v4.55a3.446 3.446 0 0 1-3.45 3.45H7.342c-.742 0-1.117-.9-.592-1.425l1.125-1.125a.825.825 0 0 1 .592-.242h3.616a.63.63 0 0 0 .625-.625.63.63 0 0 0-.625-.625h-.7c-.741 0-1.116-.9-.591-1.425l2.883-2.883a1.7 1.7 0 0 1 1.183-.484H17.5c.458 0 .833.375.833.834Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M18.142 1.858a.644.644 0 0 0-.909 0L1.858 17.242a.644.644 0 0 0 0 .908.632.632 0 0 0 .9-.008L18.142 2.758a.62.62 0 0 0 0-.9Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "m18.142 2.758-.967.967-3.567 3.567-10.85 10.85a.632.632 0 0 1-.45.191.632.632 0 0 1-.45-.191.62.62 0 0 1 0-.9l.959-.959 1.958-1.958L16.058 3.042l1.184-1.184a.62.62 0 0 1 .9 0 .62.62 0 0 1 0 .9ZM18.333 6.175c0-.742-.9-1.117-1.425-.592l-.241.25-.242.242c-.525.525-.158 1.425.583 1.425h.492a.836.836 0 0 0 .833-.833v-.492Z"
}));
export default CardSlashIcon;